
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';

/**
 * 
 */
export class CompanyLogoSizeBackfillApi extends runtime.BaseAPI {

    /**
     * Start the backfill of the size in bytes of the recorded company logos
          */
    async backfillCompanyLogoSizesRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/profile/api/admin/company-logo/size-backfill`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Start the backfill of the size in bytes of the recorded company logos
          */
    async backfillCompanyLogoSizes(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.backfillCompanyLogoSizesRaw(initOverrides);
    }

}
